
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/review/new",
      function () {
        return require("private-next-pages/community/review/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/review/new"])
      });
    }
  